import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import {formatNumber} from "@jutro/components";
import { IntlContext } from '@jutro/locale';
import metadata from './VehicleCoverageTable.metadata.json5';
import './VehicleCoverageTable.messages';

const getCell = (items, index, property) => {
    //  console.log('items: ', items[property.id])
    return !_.isObject(items[property.id]) ? items[property.id] : null;
};

const getCurrencyCell = (items, index, property) => {
    return (
        <CurrencyField
            id={`currency_${index}`}
            value={items[property.id]}
            readOnly
            hideLabel
            showOptional={false}
        />
    );
};

export function VehicleCoverageTable({ data }) {
    const overrides = {
        vehicleCoverageTable: {
            data: data
        },
        vehicleDriverTable: {
            visible: false
        }
    };
    const intl = useContext(IntlContext);

    const getCellCoverageDeductible = (rowData) => {
        if (_.isEmpty(rowData.deductible)) {
            return (
                <span>
                    {getLimitDeductible(rowData, 'Deductible')}
                </span>
            );
        }
        else {
            const formattedDeductible = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.deductible));
            return (
                <span>
                    {formattedDeductible}
                </span>
            );
        }
    };


    const getCellCoverageLimit = (rowData) => {
        if (_.isEmpty(rowData.limit)) {
            return (
                <span>
                    {getLimitDeductible(rowData, 'Limit')}
                </span>
            );
        }
        else {
            const formattedLimit = formatNumber(intl, { format: 'decimal', showFractions: true}, trimCharsAnsSpecialChars(rowData.limit));
            return (
                <span>
                    {formattedLimit}
                </span>
            );
        }
    };

    const trimCharsAnsSpecialChars = (userText) => {
        var regExpr = /[^0-9 ]/g;
        return userText.replace(regExpr, '');
    }

    const resolvers = {
        resolveCallbackMap: {
            getCellCoverage: getCell,
            getCellCurrencyCoverage: getCurrencyCell,
            getCellCoverageLimit: getCellCoverageLimit,
            getCellCoverageDeductible: getCellCoverageDeductible
        }
    };

   return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

VehicleCoverageTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

VehicleCoverageTable.defaultProps = {
    data: []
};

export function VehicleDriverTable({ data }) {
    const overrides = {
        vehicleDriverTable: {
            data: data
        },
        vehicleCoverageTable: {
            visible: false
        },

    };

    const resolvers = {
        resolveCallbackMap: {
            getCellDriver: getCell
        }
    };

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={data}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
        />
    );
}

VehicleDriverTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({}))
};

VehicleDriverTable.defaultProps = {
    data: []
};
export default { VehicleCoverageTable, VehicleDriverTable };
